<template>
  <div class="modal-authorization">
    <div class="modal-body">
    <div class="loader" v-if="loader">
      <img src="@/assets/img/loader.gif" alt="" />
    </div>
    <div class="form">
      <div class="form-menu" v-if="menu">
        <ul>
          <li
            v-bind:class="{ active: this.step === 1 }"
            @click="clickSteps(1)"
          >
            {{$t('authorization')}}
          </li>
          <li
            v-bind:class="{ active: this.step === 2 }"
            @click="clickSteps(2)"
          >
            {{$t('registration')}}
          </li>
        </ul>
      </div>
      <div class="title-m" v-if="regis">{{$t('registration')}}</div>
      <div class="form-body" v-if="step === 1">
        <v-select
          :options="[
                    { value: 'auth_phone', text: $t('by_phone_number') },
                    { value: 'auth_iin', text: $t('by_iin') }
                  ]"
          v-model="selectedAuth"
        />
        <form @submit.prevent="authForm" class="form-item">
          <masked-input
            type="tel"
            mask="\+\ 7 (111) 111 11 11"
            :placeholder="$t('phone_number')"
            v-model="phone"
            autocomplete="off"
            v-if="selectedAuth.value === 'auth_phone'"
            @input="rawVal = arguments[1]"
          />
          <input
            type="text"
            :placeholder="$t('iin')"
            maxlength="12"
            v-model="iin"
            @input="errorsDel"
            v-if="selectedAuth.value === 'auth_iin'"
            autocomplete="off"
          />
          <input
            type="password"
            :placeholder="$t('password')"
            @input="errorsDel"
            v-model="password"
          />
          <button
            class="button-yellow"
            :class="
                      (this.phone != '' && this.password != '') ||
                      (this.iin && this.password != '')
                        ? 'button-orange'
                        : 'button-orange disabled'
                    "
          >
            {{$t('login')}}
          </button>
          <div class="errors" v-if="errors">{{ errors }}</div>
        </form>
        <div class="forgot-link" @click="clickSteps(4)">
          {{$t('forgot_password')}}
        </div>
      </div>
      <div class="form-body" v-if="step === 2">
        <form class="form-item" @submit.prevent="checkIin">
          <input
            type="text"
            :placeholder="$t('iin')"
            maxlength="12"
            v-model="iin"
            @input="errorsDel"
            autocomplete="off"
          />
          <button
            :class="
                      this.iin != '' && this.iin.length == 12
                        ? 'button-yellow'
                        : 'button-yellow disabled'
                    "
          >
            {{$t('further')}}
          </button>
        </form>
        <div class="errors" v-if="errors_iin">{{ errors_iin }}</div>
      </div>
      <div class="form-body" v-if="step === 3">
        <form class="form-item" @submit.prevent="checkPhone">
          <masked-input
            type="tel"
            mask="\+\ 1 (111) 111 11 11"
            :placeholder="$t('phone_number')"
            v-model="phone"
            @input="errorsDel"
          />
          <button
            :class="
                      this.phone != '' && this.phone.length == 19
                        ? 'button-yellow'
                        : 'button-yellow disabled'
                    "
          >
            {{$t('send')}}
          </button>
          <div class="errors" v-if="errors_phone">
            {{ errors_phone }}
          </div>
        </form>
      </div>
      <div class="form-body" v-if="step === 4">
        <form action="" class="form-item" @submit.prevent="verifySms">
          <input
            type="text"
            :placeholder="$t('sms_verification_cod')"
            v-model="smscode"
            @input="errorsDel"
          />
          <button class="button-yellow">{{$t('further')}}</button>
          <div v-if="!seconds" class="sms_send">
            {{$t('send_again')}} {{ currentTime }} секунды {{$t('seconds')}}
          </div>
        </form>
        <div
          @click="checkPhone()"
          v-if="seconds"
          class="sms_send_repeat"
        >
          {{$t('send_code_again')}}
        </div>
        <div class="errors" v-if="errors_smscode">{{$t('incorrect_code')}}</div>
      </div>
    </div>
    <div class="form" v-if="step === 5">
      <form @submit.prevent="regisForm" class="form-item pd-16">
        <input type="text" :placeholder="$t('name')" v-model="firstname" />
        <input type="text" :placeholder="$t('surname')" v-model="lastname" />
        <input
          type="text"
          :placeholder="$t('middle_name')"
          v-model="middlename"
        />
        <input
          type="email"
          placeholder="Email"
          v-model="email"
          required
        />
        <div class="input">{{ phone }}</div>
        <date-picker
          v-model="bdate"
          format="DD.MM.YYYY"
          type="date"
          :placeholder="$t('date_birth')"
        ></date-picker>
        <div class="form-flex">
          <input
            type="radio"
            id="male"
            name="male"
            value="0"
            v-model="gender"
            checked="checked"
          />
          <label for="male">{{$t('male')}}</label>
          <input
            type="radio"
            id="female"
            name="female"
            value="1"
            v-model="gender"
          />
          <label for="female">{{$t('female')}}</label>
        </div>
        <v-select
          textProp="name"
          valueProp="id"
          v-model="selectedCity"
          :options="cities"
        />
        <input
          type="password"
          :placeholder="$t('password')"
          v-model="password"
        />
        <input
          type="password"
          :placeholder="$t('repeat_password')"
          v-model="repeat_password"
        />
        <!-- <input
          type="text"
          :placeholder="$t('referral_code')"
          v-model="refcode"
        /> -->
        <div class="form-label">
          <input type="checkbox" v-model="regulations" />
          <div class="prav">{{$t('i_agree')}}</div>
        </div>
        <button
          :class="
                    this.regulations != '' &&
                    this.firstname != '' &&
                    this.lastname != '' &&
                    this.middlename != '' &&
                    this.email != '' &&
                    this.bdate != '' &&
                    this.password != '' &&
                    this.password === this.repeat_password
                      ? 'button-yellow'
                      : 'button-yellow disabled'
                  "
        >
          {{$t('further')}}
        </button>
      </form>
    </div>
    <div class="form form-password" v-if="step === 6">
      <div class="title-m">{{$t('password_recovery')}}</div>
      <div class="form-menu" v-if="pass_rec">
        <ul>
          <li
            v-bind:class="{ active: this.pass === 1 }"
            @click="clickSteps(5)"
          >
            {{$t('by_phone')}}
          </li>
          <li
            v-bind:class="{ active: this.pass === 2 }"
            @click="clickSteps(6)"
          >
            {{$t('by_email')}}
          </li>
        </ul>
      </div>
      <div v-if="this.pass === 1">
        <div class="form-body" v-if="step_pass === 1">
          <form
            @submit.prevent="changePasswordPhone()"
            class="form-item"
          >
            <masked-input
              type="tel"
              mask="\+\ 1 (111) 111 11 11"
              :placeholder="$t('phone_number')"
              v-model="phone"
              @input="errorsDel"
              autocomplete="off"
            />
            <button
              :class="
                        this.phone != '' && this.phone.length == 19
                          ? 'button-yellow'
                          : 'button-yellow disabled'
                      "
            >
              {{$t('restore')}}
            </button>
          </form>
        </div>
        <div class="form-body" v-if="step_pass === 2">
          <form
            action=""
            class="form-item"
            @submit.prevent="changePasswordSmsVerify()"
          >
            <input
              type="text"
              :placeholder="$t('sms_verification_cod')"
              v-model="smscode"
              @input="errorsDel"
            />
            <button class="button-yellow">{{$t('further')}}</button>
            <div v-if="!seconds" class="sms_send">
              {{$t('send_again')}} {{ currentTime }} {{$t('seconds')}}
            </div>
          </form>
          <div
            @click="changePasswordPhone()"
            v-if="seconds"
            class="sms_send_repeat"
          >
            {{$t('send_again')}}
          </div>
          <div class="errors" v-if="errors_smscode">
            {{ errors_smscode }}
          </div>
        </div>
        <div class="form-body" v-if="step_pass === 3">
          <form
            action=""
            class="form-item"
            @submit.prevent="changePasswordLast()"
          >
            <input
              type="password"
              :placeholder="$t('password')"
              v-model="password"
            />
            <input
              type="password"
              :placeholder="$t('repeat_password')"
              v-model="repeat_password"
            />
            <button
              :class="
                        this.password != '' &&
                        this.repeat_password != '' &&
                        this.password === this.repeat_password
                          ? 'button-yellow'
                          : 'button-yellow disabled'
                      "
            >
              {{$t('restore')}}
            </button>
          </form>
          <div class="errors" v-if="errors">{{ errors }}</div>
        </div>
      </div>
      <div v-if="this.pass === 2">
        <div class="form-body" v-if="step_pass2 === 1">
          <form @submit.prevent="changePasswordEmail" class="form-item">
            <input
              type="email"
              placeholder="Email"
              required=""
              v-model="email"
              @input="errorsDel"
            />
            <button
              :class="
                        this.email != ''
                          ? 'button-yellow'
                          : 'button-yellow disabled'
                      "
            >
              {{$t('restore')}}
            </button>
            <div class="errors" v-if="errors_email">
              {{ errors_email }}
            </div>
          </form>
        </div>
        <div v-if="step_pass2 === 2" class="success_email">
          <div class="success">{{ success_email }}</div>
          <button
            class="button-yellow"
            data-dismiss="modal"
            aria-hidden="true"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
import VSelect from '@alfsnd/vue-bootstrap-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
import {formatToSend} from '../helpers'

export default {
  name: 'authorization',
  components: {
    VSelect,
    MaskedInput,
    DatePicker
  },
  data () {
    return {
      step: 1,
      selectedAuth: { value: 'auth_phone', text: this.$t('by_phone_number') },
      iin: '',
      password: '',
      repeat_password: '',
      errors: '',
      loader: false,
      username: null,
      pass: 1,
      phone: null,
      phone_empty: null,
      smscode: null,
      user: '',
      firstname: '',
      lastname: '',
      middlename: '',
      city: '',
      gender: 0,
      bdate: '',
      // refcode: "",
      email: '',
      regulations: false,
      cities: [],
      selectedCity: {},
      errors_iin: '',
      currentTime: 60,
      seconds: false,
      errors_smscode: '',
      errors_phone: '',
      menu: true,
      regis: false,
      success_email: '',
      errors_email: '',
      pass_rec: true,
      step_pass: 1,
      step_pass2: 1
    }
  },
  mounted () {
    var obj = this
    $('#modal-authorization').on('hidden.bs.modal', function () {
      obj.step = 1
      obj.selectedAuth = { value: 'auth_phone', text: this.$t('by_phone_number') }
      obj.iin = ''
      obj.password = ''
      obj.repeat_password = ''
      obj.errors = ''
      obj.loader = false
      obj.username = null
      obj.pass = 1
      obj.phone = null
      obj.phone_empty = null
      obj.smscode = null
      obj.user = ''
      obj.firstname = ''
      obj.lastname = ''
      obj.middlename = ''
      obj.city = ''
      obj.gender = 0
      obj.bdate = ''
      // obj.refcode = "";
      obj.email = ''
      obj.regulations = false
      obj.cities = []
      obj.selectedCity = {}
      obj.errors_iin = ''
      obj.currentTime = 60
      obj.seconds = false
      obj.errors_smscode = ''
      obj.errors_phone = ''
      obj.menu = true
      obj.regis = false
      obj.success_email = ''
      obj.errors_email = ''
      obj.pass_rec = true
      obj.step_pass = 1
      obj.step_pass2 = 1
    })
  },
  created () {
    this.getСitiesList()
  },
  methods: {
    clickSteps (index) {
      if (index == 1) {
        this.step = 1
      }
      if (index == 2) {
        this.step = 2
      }
      if (index == 4) {
        this.step = 6
        this.menu = false
      }
      if (index == 5) {
        this.pass = 1
      }
      if (index == 6) {
        this.pass = 2
      }
    },
    getСitiesList () {
      this.$axios
        .get('/location/cities-list')
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
          } else {
            this.cities = $response.data
            this.selectedCity = {
              id: this.cities[0].id,
              name: this.cities[0].name
            }
          }
        })
        .catch(e => console.log(e))
    },
    authForm () {
      this.loader = true
      if (this.selectedAuth.value == 'auth_phone') {
        this.username = formatToSend(this.phone)
      } else {
        this.username = this.iin
      }
      let obj = {}
      obj['username'] = this.username
      obj['password'] = this.password
      this.$axios
        .post('/user/login', obj)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors = $response.message
            this.loader = false
          } else {
            this.loader = false
            this.iin = $response.data.iin
            this.$auth.saveUser($response.data)
            this.$auth.saveToken(
              'Basic ' + btoa(this.iin + ':' + this.password)
            )
            window.location.replace('/cabinet')
          }
        })
        .catch(e => console.log(e))
    },
    errorsDel () {
      this.errors = ''
      this.errors_smscode = ''
      this.errors_iin = ''
      this.errors_phone = ''
      this.errors_email = ''
    },
    checkIin () {
      this.loader = true
      this.$axios
        .get('/user/checkiin?iin=' + this.iin)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.errors_iin = $response.message
            this.loader = false
          } else {
            this.step = 3
            this.menu = false
            this.regis = true
            this.loader = false
          }
        })
        .catch(e => console.log(e))
    },
    checkPhone () {
      this.currentTime = 60
      const phone = formatToSend(this.phone)
      this.loader = true
      this.$axios
        .get('/user/registerphone?phone=' + phone + '&iin=' + this.iin)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.errors_phone = $response.message
            this.loader = false
          } else {
            this.step = 4
            this.menu = false
            this.regis = true
            this.loader = false
            this.seconds = false
            setInterval(() => {
              this.currentTime--
            }, 1000)
            this.secondsFunc()
          }
        })
        .catch(e => console.log(e))
    },
    verifySms () {
      this.loader = true
      let obj = {}
      obj['username'] = this.iin
      obj['password'] = this.smscode
      this.$axios
        .post('/user/login', obj)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors_smscode = $response.errors
            this.loader = false
          } else {
            this.step = 5
            this.menu = false
            this.regis = true
            this.user = $response.data
            this.loader = false
          }
        })
        .catch(e => console.log(e))
    },
    secondsFunc () {
      this.seconds = false
      var self = this
      setTimeout(function () {
        self.seconds = true
      }, 60000)
    },
    regisForm () {
      if (this.regulations == true && this.password == this.repeat_password) {
        this.bdate = moment(this.bdate).format('YYYY-MM-DD')
        this.gender = Number(String(this.gender))
        this.loader = true
        let obj = {}
        const config = {
          headers: {
            Authorization: 'Basic ' + btoa(this.iin + ':' + this.smscode)
          }
        }
        obj['firstname'] = this.firstname
        obj['lastname'] = this.lastname
        obj['middlename'] = this.middlename
        obj['bdate'] = this.bdate
        obj['city_id'] = this.selectedCity.id
        obj['email'] = this.email
        obj['gender'] = this.gender
        obj['password'] = this.password
        // obj["refcode"] = this.refcode;
        obj['phone'] = formatToSend(this.phone)
        obj['iin'] = this.iin
        this.$axios
          .post('/user/save', obj, config)
          .then(response => {
            this.authForm()
          })
          .catch(e => console.log(e))
      }
    },
    changePasswordEmail () {
      this.loader = true
      let obj = {}
      obj['email'] = this.email
      this.$axios
        .post('/user/resetpassword-email', obj)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors_email = $response.message
            this.loader = false
          } else {
            this.loader = false
            this.step_pass2 = 2
            this.pass_rec = false
            this.success_email = $response.message
          }
        })
        .catch(e => console.log(e))
    },
    changePasswordPhone () {
      const phone = formatToSend(this.phone)
      this.currentTime = 60
      this.loader = true
      this.$axios
        .get('/user/forget?phone=' + phone)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.errors_phone = $response.message
            this.loader = false
          } else {
            this.step_pass = 2
            this.seconds = false
            this.loader = false
            this.pass_rec = false
            setInterval(() => {
              this.currentTime--
            }, 1000)
            this.secondsFunc()
          }
        })
        .catch(e => console.log(e))
    },
    changePasswordSmsVerify () {
      this.loader = true
      let obj = {}
      obj['phone'] = formatToSend(this.phone)
      obj['smscode'] = this.smscode
      this.$axios
        .post('/user/checkcode', obj)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.errors_smscode = $response.message
            this.loader = false
          } else {
            this.step_pass = 3
            this.loader = false
          }
        })
        .catch(e => console.log(e))
    },
    changePasswordLast () {
      this.loader = true
      let obj = {}
      obj['phone'] = formatToSend(this.phone)
      obj['smscode'] = this.smscode
      obj['password'] = this.password
      obj['password_confirm'] = this.repeat_password
      this.$axios
        .post('/user/newpassword', obj)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            this.errors = $response.message
            this.loader = false
          } else {
            this.loader = false
            this.iin = $response.data.iin
            this.$auth.saveUser($response.data)
            this.$auth.saveToken(
              'Basic ' + btoa(this.iin + ':' + this.password)
            )
            window.location.replace('/cabinet')
          }
        })
        .catch(e => console.log(e))
    }
  }
}
</script>
<style scoped>
.modal-authorization {
  max-width: 560px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Auth.vue